export default __webpack_public_path__ + "static/media/LineosoftArticleListing2-min.063a3d9d.PNG";